/* =============================================================================
   muc-reveal.js · efectos ligeros de la home de Mi Universo Cuántico (sin librerías, `defer`)
   Portado de la home v7.6 (Web/Mi-Universo-Cuantico-Oro-v7.html):
     REVEAL (1608-1612) · FRASES (1750-1760) · H1 por líneas (1813-1826) · símbolo parte a parte (2150-2158)
     · lista de espera (2160-2172) · botones magnéticos (2187-2192) · FAQ «ver más» (2357-2358)
   Cada efecto se activa solo si encuentra su marca en el HTML (data-muc-*); nada se pinta aquí.
   Respeta prefers-reduced-motion. Se reinicia en el editor de temas (shopify:section:load).
   Se puede cargar desde varias secciones: la guarda evita ejecutarlo dos veces.
   ========================================================================== */
(() => {
  if (window.__mucReveal) return;
  window.__mucReveal = true;

  const raiz = document.documentElement;
  raiz.classList.add('muc-js');

  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fino = matchMedia('(pointer: fine)').matches;
  const Q = (s, r = document) => r.querySelector(s);
  const QQ = (s, r = document) => [...r.querySelectorAll(s)];
  const una = (el, clave) => {
    if (el.dataset[clave]) return false;
    el.dataset[clave] = '1';
    return true;
  };

  /* ---------- REVEAL: aparición al entrar en pantalla (solo si la sección lo activa) ---------- */
  let io = null;
  const reveal = (r) => {
    if (!('IntersectionObserver' in window)) {
      QQ('.muc-rv', r).forEach((el) => el.classList.add('in'));
      return;
    }
    io =
      io ||
      new IntersectionObserver(
        (es) =>
          es.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          }),
        { threshold: 0.1 }
      );
    QQ('.muc-rv', r).forEach((el) => una(el, 'mucRv') && io.observe(el));
  };

  /* ---------- H1: revelado por líneas con máscara ---------- */
  const lineas = (r) => {
    if (quieto) return;
    QQ('[data-muc-lineas]', r).forEach((h1) => {
      if (!una(h1, 'mucLineasListo')) return;
      const partir = () => {
        const palabras = [];
        (function rec(n, em) {
          [...n.childNodes].forEach((c) => {
            if (c.nodeType === 3) c.textContent.split(/\s+/).filter(Boolean).forEach((w) => palabras.push({ w, em }));
            else rec(c, c.tagName === 'EM' || em);
          });
        })(h1, false);
        h1.innerHTML = palabras.map((o) => `<span class="muc-pw">${o.em ? '<em>' + o.w + '</em>' : o.w}</span>`).join(' ');
        const filas = [];
        let top = null;
        QQ('.muc-pw', h1).forEach((s) => {
          if (s.offsetTop !== top) {
            filas.push([]);
            top = s.offsetTop;
          }
          filas[filas.length - 1].push(s.innerHTML);
        });
        h1.innerHTML = filas
          .map((l, i) => `<span class="muc-ln"><span style="animation-delay:${0.15 + i * 0.12}s">${l.join(' ')}</span></span>`)
          .join('');
        h1.classList.add('muc-lineas');
      };
      (document.fonts ? document.fonts.ready : Promise.resolve()).then(partir);
    });
  };

  /* ---------- FRASES: rotación con puntos ---------- */
  const frases = (r) => {
    QQ('[data-muc-frases]', r).forEach((caja) => {
      if (!una(caja, 'mucFrasesListo')) return;
      const el = Q('[data-muc-frase]', caja);
      const puntos = Q('[data-muc-puntos]', caja);
      const datos = Q('[data-muc-frases-datos]', caja);
      if (!el || !puntos || !datos) return;
      let lista = [];
      try {
        lista = JSON.parse(datos.textContent)
          .map((s) => String(s).trim())
          .filter(Boolean);
      } catch (e) {
        return;
      }
      if (lista.length < 2) return;
      const etiqueta = caja.dataset.etiquetaPunto || '';
      const ms = Math.max(3000, parseInt(caja.dataset.intervalo, 10) || 6000);
      let i = 0;
      let timer;
      lista.forEach((_, j) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (etiqueta + ' ' + (j + 1)).trim());
        b.addEventListener('click', () => {
          ir(j);
          reiniciar();
        });
        puntos.appendChild(b);
      });
      function ir(j) {
        i = j;
        [...puntos.children].forEach((b, k) => b.classList.toggle('on', k === i));
        if (quieto) {
          el.textContent = lista[i];
          return;
        }
        el.style.opacity = 0;
        setTimeout(() => {
          el.textContent = lista[i];
          el.style.opacity = 1;
        }, 400);
      }
      function reiniciar() {
        clearInterval(timer);
        if (!quieto) timer = setInterval(() => ir((i + 1) % lista.length), ms);
      }
      ir(0);
      reiniciar();
    });
  };

  /* ---------- botones magnéticos (solo ratón y sin movimiento reducido) ---------- */
  const magneticos = (r) => {
    if (quieto || !fino) return;
    QQ('[data-muc-magnet]', r).forEach((b) => {
      if (!una(b, 'mucMagnetListo')) return;
      b.style.transition = 'transform .5s var(--muc-spring)';
      b.addEventListener('pointermove', (e) => {
        const c = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - c.left - c.width / 2) * 0.2}px,${(e.clientY - c.top - c.height / 2) * 0.3}px)`;
      });
      b.addEventListener('pointerleave', () => {
        b.style.transform = '';
      });
    });
  };

  /* ---------- Nuestra esencia: el símbolo se explica parte a parte ---------- */
  const simbolo = (r) => {
    QQ('[data-muc-sello]', r).forEach((envoltorio) => {
      if (!una(envoltorio, 'mucSelloListo')) return;
      const seccion = envoltorio.closest('.muc') || document;
      const sigs = QQ('.muc-paso--significado', seccion);
      if (!sigs.length) return;
      const hots = [];
      sigs.forEach((s, i) => {
        if (!s.dataset.mucPuntoX) return;
        const h = document.createElement('span');
        h.className = 'muc-hot' + (s.hasAttribute('data-muc-punto-izq') ? ' izq' : '');
        h.dataset.i = i;
        h.dataset.t = (Q('.muc-paso__titulo', s) || {}).textContent || '';
        h.style.setProperty('--x', s.dataset.mucPuntoX + '%');
        h.style.setProperty('--y', s.dataset.mucPuntoY + '%');
        h.setAttribute('aria-hidden', 'true');
        envoltorio.appendChild(h);
        hots.push(h);
      });
      const activar = (i) => {
        sigs.forEach((s, j) => s.classList.toggle('on', j === i));
        hots.forEach((h) => h.classList.toggle('on', Number(h.dataset.i) === i));
      };
      activar(0);
      if (matchMedia('(max-width: 960px)').matches) {
        if (quieto) return;
        let i = 0;
        setInterval(() => {
          if (!document.hidden) activar((i = (i + 1) % sigs.length));
        }, 3200);
      } else if ('IntersectionObserver' in window) {
        const obs = new IntersectionObserver(
          (es) =>
            es.forEach((e) => {
              if (e.isIntersecting) activar(sigs.indexOf(e.target));
            }),
          { rootMargin: '-45% 0px -45% 0px' }
        );
        sigs.forEach((s) => obs.observe(s));
      }
      sigs.forEach((s, j) => s.addEventListener('pointerenter', () => activar(j)));
    });
  };

  /* ---------- Arquitectura: lista de espera (formulario «customer» de Shopify con etiquetas) ---------- */
  /* contenedor de scroll como en Horizon (scroll-container.js): en escritorio ≥ 990 px es .page-wrapper, en móvil la ventana */
  const contenedorScroll = () =>
    matchMedia('(min-width: 990px)').matches
      ? document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement
      : document.scrollingElement || document.documentElement;
  const espera = (r) => {
    QQ('[data-muc-espera]', r).forEach((caja) => {
      if (!una(caja, 'mucEsperaListo')) return;
      const seccion = caja.closest('.muc') || document;
      const lista = QQ('.muc-espera__chips', caja)[0]; /* la sección no lee los ajustes de sus bloques: las casillas salen de las tarjetas «Próximamente» */
      if (lista && !QQ('[data-muc-chip]', lista).length) QQ('[data-muc-universo]', seccion).forEach((u) => {
        const l = document.createElement('label'), i = document.createElement('input'), s = document.createElement('span');
        i.type = 'checkbox'; i.value = u.dataset.mucUniverso; i.setAttribute('data-muc-chip', '');
        s.textContent = (u.querySelector('.muc-universo__nombre') || u).textContent.trim();
        l.append(i, s); lista.appendChild(l);
      });
      const enviado = Q('.muc-espera__ok', caja); /* tras enviar, Shopify recarga la página: volver a la posición exacta donde estaba la persona */
      if (enviado) {
        enviado.setAttribute('tabindex', '-1');
        let y = null;
        try { y = sessionStorage.getItem('mucEsperaY'); sessionStorage.removeItem('mucEsperaY'); } catch (err) { y = null; }
        const destino = y !== null && !isNaN(Number(y)) ? Number(y) : null;
        /* la URL queda con ?customer_posted=true: se limpia, así recargar no repite el estado «enviado» ni el desplazamiento */
        try {
          const u = new URL(location.href);
          ['customer_posted', 'form_type', 'utf8'].forEach((k) => u.searchParams.delete(k));
          history.replaceState(history.state, '', u.pathname + u.search + u.hash);
        } catch (err) { /* sin History API: no pasa nada */ }
        /* posición: se restaura la exacta (o se centra la caja) cada 120 ms durante ~3 s, y se para en cuanto la persona interactúa */
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        const eventos = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
        let activo = true, veces = 0;
        const parar = () => {
          if (!activo) return;
          activo = false;
          if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
          eventos.forEach((ev) => removeEventListener(ev, parar));
        };
        eventos.forEach((ev) => addEventListener(ev, parar, { passive: true }));
        const poner = () => {
          if (!activo) return;
          if (destino !== null) contenedorScroll().scrollTo({ top: destino, behavior: 'instant' });
          else caja.scrollIntoView({ behavior: 'auto', block: 'center' });
          if (++veces < 25) setTimeout(poner, 120); else parar();
        };
        poner();
        enviado.focus({ preventScroll: true });
      }
      const abrir = (u) => {
        const chip = QQ('[data-muc-chip]', caja).find((c) => c.value === u.dataset.mucUniverso);
        if (chip) chip.checked = true;
        caja.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'center' });
        setTimeout(() => {
          const correo = Q('input[type=email]', caja);
          if (correo) correo.focus({ preventScroll: true });
        }, 600);
      };
      QQ('[data-muc-universo]', seccion).forEach((u) => {
        u.addEventListener('click', () => abrir(u));
        u.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            abrir(u);
          }
        });
      });
      const t0 = Date.now(); /* antispam invisible: cebo + tiempo mínimo + etiqueta de verificación (ajustes de la sección) */
      caja.addEventListener('submit', (e) => {
        const etiquetas = Q('[data-muc-etiquetas]', caja);
        const miel = Q('[data-muc-miel]', caja);
        const seg = Number(etiquetas && etiquetas.dataset.segundos);
        const prisa = Q('[data-muc-prisa]', caja);
        if (miel && miel.value) { e.preventDefault(); return; }
        if (Date.now() - t0 < (isNaN(seg) ? 3 : seg) * 1000) {
          e.preventDefault();
          if (prisa) prisa.hidden = false;
          return;
        }
        if (prisa) prisa.hidden = true;
        try { sessionStorage.setItem('mucEsperaY', String(Math.round(contenedorScroll().scrollTop))); } catch (err) { /* sin almacenamiento: se centra la caja */ }
        const elegidos = QQ('[data-muc-chip]:checked', caja).map((c) => 'espera:' + c.value);
        const verif = etiquetas && etiquetas.dataset.verif;
        if (etiquetas) etiquetas.value = [etiquetas.dataset.base || 'lista-espera', ...(verif ? [verif] : []), ...elegidos].join(', ');
        /* envío sin recargar la página (la recarga era la causa de los saltos de scroll): fetch al mismo formulario.
           Si algo no es un alta limpia (reto antibot /challenge, error de correo, sin fetch o sin plantilla), se envía el formulario normal como siempre */
        const plantilla = Q('template[data-muc-ok]', caja);
        const boton = Q('button[type=submit]', caja);
        if (!window.fetch || !window.FormData || !plantilla || (boton && boton.disabled)) return;
        e.preventDefault();
        e.stopPropagation(); /* el rastreador de Shopify (Trekkie) escucha «submit» en el documento y reenvía con form.submit() los envíos cancelados: provocaba la recarga */
        const formulario = e.target;
        if (boton) boton.disabled = true;
        const normal = () => { try { sessionStorage.removeItem('mucEsperaY'); } catch (err) { /* nada */ } if (boton) boton.disabled = false; HTMLFormElement.prototype.submit.call(formulario); };
        fetch(formulario.action, { method: 'POST', body: new FormData(formulario), credentials: 'same-origin', redirect: 'follow' })
          .then((res) => {
            if (!res.ok || /\/challenge/.test(res.url) || !/customer_posted=true/.test(res.url)) { normal(); return; }
            try { sessionStorage.removeItem('mucEsperaY'); } catch (err) { /* nada */ }
            const ok = plantilla.content.firstElementChild.cloneNode(true);
            ok.setAttribute('tabindex', '-1');
            caja.style.minHeight = caja.offsetHeight + 'px'; /* la caja conserva su alto: nada de debajo se mueve */
            QQ('form > :not(template):not(input[type=hidden])', caja).forEach((n) => { n.style.display = 'none'; });
            formulario.appendChild(ok);
            ok.focus({ preventScroll: true });
          })
          .catch(normal);
      });
    });
  };

  /* ---------- FAQ: ver más / ver menos ---------- */
  const faq = (r) => {
    QQ('[data-muc-faq-boton]', r).forEach((b) => {
      if (!una(b, 'mucFaqListo')) return;
      const mas = document.getElementById(b.getAttribute('aria-controls'));
      if (!mas) return;
      b.addEventListener('click', () => {
        mas.hidden = !mas.hidden;
        b.setAttribute('aria-expanded', String(!mas.hidden));
        b.textContent = mas.hidden ? b.dataset.verMas : b.dataset.verMenos;
      });
    });
  };

  const iniciar = (r) => {
    reveal(r);
    lineas(r);
    frases(r);
    magneticos(r);
    simbolo(r);
    espera(r);
    faq(r);
  };

  iniciar(document);
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
